import category from "./category.json";

export default {
  category,
};
